import { render, staticRenderFns } from "./NivosesLayer.vue?vue&type=template&id=644947fa&scoped=true"
import script from "./NivosesLayer.vue?vue&type=script&lang=js"
export * from "./NivosesLayer.vue?vue&type=script&lang=js"
import style0 from "./NivosesLayer.vue?vue&type=style&index=0&id=644947fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644947fa",
  null
  
)

export default component.exports